var _excluded = ["mode", "popoverProps"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Popover } from '../Popover.old';
export var PopoverDisplayMode;

(function (PopoverDisplayMode) {
  PopoverDisplayMode["OnClick"] = "click";
  PopoverDisplayMode["Hover"] = "hover";
})(PopoverDisplayMode || (PopoverDisplayMode = {}));

export function withTooltip(Component) {
  return function InnerWithTooltip(_ref) {
    var _popoverProps$open;

    var mode = _ref.mode,
        popoverProps = _ref.popoverProps,
        restProps = _objectWithoutProperties(_ref, _excluded);

    var componentRef = React.useRef(null);

    var _React$useState = React.useState((_popoverProps$open = popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.open) !== null && _popoverProps$open !== void 0 ? _popoverProps$open : false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        isOpen = _React$useState2[0],
        setIsOpen = _React$useState2[1];

    function onMouseEnter() {
      setIsOpen(true);
    }

    function onMouseLeave() {
      setIsOpen(false);
    }

    function onClick() {
      setIsOpen(true);
    }

    React.useLayoutEffect(function () {
      var ref = componentRef === null || componentRef === void 0 ? void 0 : componentRef.current;

      if (!ref) {
        return;
      }

      if (mode === PopoverDisplayMode.Hover) {
        ref.addEventListener('mouseenter', onMouseEnter);
        ref.addEventListener('mouseleave', onMouseLeave);
      } else if (mode === PopoverDisplayMode.OnClick) {
        ref.addEventListener('click', onClick);
      }

      return function () {
        if (mode === PopoverDisplayMode.Hover) {
          ref.removeEventListener('mouseenter', onMouseEnter);
          ref.removeEventListener('mouseleave', onMouseLeave);
        } else if (mode === PopoverDisplayMode.OnClick) {
          ref.removeEventListener('click', onClick);
        }
      };
    }, [mode]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, _extends({
      ref: componentRef
    }, restProps)), componentRef.current && /*#__PURE__*/React.createElement(Popover, _extends({}, popoverProps, {
      open: isOpen,
      anchorEl: componentRef.current,
      onClose: function onClose() {
        return setIsOpen(false);
      }
    })));
  };
}